import { DynamicLinkType } from '@nimbus/portal-service';
import {
  FlexibleBlockBrick,
  FlexibleBlockBrickAvatarStyle,
  FlexibleBlockBrickRatingStyle,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { brickCommon } from './common';

const customBrickCommon = { ...brickCommon, removable: true, switchable: true, sortable: true };

export const customBricksList: FlexibleBlockBrick[] = [
  {
    ...customBrickCommon,
    brickType: 'title',
    brickName: 'Heading',
    text: 'Heading',
    placeholder: 'Here, you can add title',
    className: ['p-0', 'text-xl', 'font-bold'],
    theme: { text: { main: PortalTextType.SURFACE } },
  },
  {
    ...customBrickCommon,
    brickType: 'text',
    brickName: 'Paragraph',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    placeholder: 'Here, you can add text',
    className: ['p-0', 'text-lg'],
    theme: { text: { main: PortalTextType.SURFACE } },
  },
  {
    ...customBrickCommon,
    brickType: 'link',
    brickName: 'Link',
    dynamicLink: {
      type: DynamicLinkType.EXTERNAL,
      title: 'Custom link',
      url: 'https://google.com',
    },
    className: ['p-0', 'text-lg'],
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
    },
  },
  {
    ...customBrickCommon,
    brickType: 'image',
    brickName: 'Image',
    switchable: true,
    src: '/assets/img/blocks/card/card-img.jpg',
    className: ['m-0', 'rounded-md'],
  },
  {
    ...customBrickCommon,
    brickType: 'button',
    brickName: 'Button',
    switchable: true,
    text: 'Explore',
    noLink: false,
    className: ['p-0'],
  },
  {
    ...customBrickCommon,
    brickType: 'avatar',
    brickName: 'Avatar',
    src: '/assets/img/blocks/avatar/avatar.png',
    name: 'Amelia Wells',
    description: 'Your Personal Assistant',
    style: FlexibleBlockBrickAvatarStyle.RING,
    className: ['p-0', 'justify-start'],
    theme: {
      text: {
        main: PortalTextType.HEADER,
      },
    },
  },
  {
    ...customBrickCommon,
    brickType: 'rating',
    brickName: 'Rating',
    style: FlexibleBlockBrickRatingStyle.STAR,
    value: 5,
    colored: true,
    className: ['p-0', 'justify-start'],
  },
];
